import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AIcon } from './';

export default function AButtonIndicator({
	value,
	icon,
	intlValue,
	onClick,
	disabled,
	className,
}) {
	return (
		<div
			className={`a-indicator-button ${disabled ? 'disabled' : ''} ${className}`}
			role="button"
			tabIndex="0"
			disabled={disabled}
		>
			<AIcon type={icon} className="small" />
			<button
				className="a-button indicator-button"
				onClick={onClick}
			>
				<FormattedMessage id={value} values={intlValue} />
			</button>
		</div>
	);
}

AButtonIndicator.propTypes = {
	value: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	intlValue: PropTypes.any,
	onClick: PropTypes.func,
};

AButtonIndicator.defaultProps = {
	disabled: false,
	intlValue: undefined,
	onClick: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.button-indicator.js